<template>
  <div class="notes-module ffm400" data-position="1" data-name="免责申明">
    <div class="umx-tips-box">
      <p>注释</p>
      <ul>
        <li>* 本页面所展示的产品界面与功能说明（包括但不限于 UI、背景、产品功能、手机轮廓或手机外观图等）仅供参考，部分功能可能因系统版本、机型不同而存在差异，请以实际呈现效果为准。</li>
        <li>* 本页面及OriginOS 6发布会中涉及到的部分内容和功能，仅支持部分机型或首批仅支持部分机型，请以产品实际使用为准。</li>
        <li>* 部分功能后续随OTA升级更新，当前界面及功能示意仅供参考，请以实际使用为准。</li>
        <li>* 趣味光栅、个性锁屏：画面内容仅为广告创意示意，部分功能仅支持特定机型，实际效果请以实机体验为准。</li>
        <li>* 双渲染架构、超核计算、光子存储：数据源自vivo实验室，测试机型、版本为：vivo X200 Ultra OriginOS 6对比vivo X200 Ultra OriginOS 5，因平台/机型不同，效果存在差异，请以实际使用为准。</li>
        <li>* 相关测试数据源自我司实验室，5年持久流畅非指绝对流畅不卡顿，因机器老化、网络环境、个人使用习惯等因素不同，体验可能有所差异，请以实际体验为准。</li>
        <li>* 场景能效2.0、系统轻量化3.0：相关数据基于vivo实验室在特定测试条件下对vivo X200 Pro机型的测试结果。由于不同机型、使用环境及个人使用习惯存在差异，最终效果请以实际使用情况为准。</li>
        <li>* 全局直驱供电2.0：手机充电效率与发热情况，由于不同机型、使用环境及个人使用习惯存在差异，最终效果请以实际使用情况为准。</li>
        <li>* Live Photo AI消除：画面内容仅为广告创意示意，部分功能仅支持特定机型，实际效果请以实机体验为准。</li>
        <li>* vivo输入法仅在部分机型内置，可前往应用商店下载安装。</li>
        <li>* 摇一摇群组分享：vivo手机需升级至OriginOS 6，iPhone需升级至iOS16及以上系统版本，并安装5.4.0及以上版本的“vivo互传”App方可使用此功能。该功能需要搭配第三方服务来实现，可能因第三方服务原因导致相关功能发生变化，vivo将根据实际情况更新功能宣传页面内的描述，请以实际使用的情况为准。</li>
        <li>* vivo办公套件-跨端文件随心传：电脑端vivo办公套件需升级至v6.0.0及以上版本，手机端需升级至OriginOS 6，且内存大于4G。</li>
        <li>* iPad互联：请在iPad的App Store中搜索“vivo 办公套件”，并完成安装后使用。</li>
        <li>* 一句话控家：本功能需在兼容的设备和网络环境下使用，实际体验可能因设备型号、品牌协议或用户设置而有所差异。并非所有品牌或型号均支持组合操作，相关服务可能因第三方设备或平台调整而发生变化，具体以实际支持情况为准。</li>
        <li>* 镜像小窗2.0：当前支持小鹏汽车部分车型，且车端系统版本需高于V5.9，更多车型持续适配中。</li>
        <li>* AI舒眠模式：数据来源于vivo实验室，测试结果基于对比AI舒眠模式开启前后的表现。请注意：本功能仅用于提升使用体验，手机并非医疗器械，不具备任何治疗或医疗功效。上述数据和效果仅供参考，最终效果请以实际使用情况为准。</li>
        <li>* 助听器LE音频当前已支持vivo X300和vivo X300 Pro机型，未来将适配更多机型。画面仅为广告创意，功能示意仅供参考，最终效果请以实际使用情况为准。</li>
        <li>* 对于本页面所展示内容的具体机型适配计划及支持情况，将于vivo官方新媒体渠道公布；您也可以通过咨询vivo官方客服进行了解。</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { initExposureTrack } from "@/utils/track.js";
export default {
  name: "NotesModule",
  mounted(){
    // 曝光埋点
    this.$nextTick(() => {
      initExposureTrack(".notes-module")();
    });
  },
};
</script>
<style lang="scss" scoped>
.notes-module {
  background-color: #000;
  padding: 114 * $px1920vw + vw 240 * $px1920vw + vw 80 * $px1920vw + vw 230 * $px1920vw + vw;
  text-align: left;
  position: relative;
  p {
    padding-bottom: 20 * $px1920vw + vw;
    color: #fff;
    font-size: 16 * $px1920vw + vw;
  }
  li {
    color: #a1a1a6;
    line-height: 32 * $px1920vw + vw;
    font-size: 16 * $px1920vw + vw;
  }
  a {
    text-decoration: underline;
  }
}
.isPad {
  .notes-module {
    padding: 48 * $px676vw + vw 58 * $px676vw + vw;
    p {
      padding-bottom: 0;
      line-height: 14 * $px676vw + vw;
      font-size: 9 * $px676vw + vw;
    }
    li {
      line-height: 18 * $px676vw + vw;
      font-size: 9 * $px676vw + vw;
      line-height: 14 * $px676vw + vw;
    }
  }
}
.isMobile {
  .notes-module {
    padding: 57 * $px360vw + vw 19 * $px360vw + vw 61 * $px360vw + vw 19 * $px360vw + vw;
    p {
      font-size: 16 * $px360vw + vw;
      line-height: 19 * $px360vw + vw;
      padding-bottom: 20 * $px360vw + vw;
    }
    li {
      line-height: 22 * $px360vw + vw;
      font-size: 12 * $px360vw + vw;
    }
  }
}
</style>